'use client';

import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import ExerciseView from '@/components/ExerciseView';
import ParticipantList from '@/components/ParticipantList';

export default function ExerciseContent() {
  const searchParams = useSearchParams();
  const sessionId = searchParams.get('s') || 'demo-session';
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Hub connection will be established here
    setIsConnected(true);
  }, [sessionId]);

  return (
    <main className="min-h-screen p-4">
      <div className="max-w-6xl mx-auto">
        <header className="flex justify-between items-center mb-6 p-4 bg-gray-100 dark:bg-gray-800 rounded-lg">
          <div>
            <h1 className="text-2xl font-bold">Exercise Session</h1>
            <p className="text-sm text-gray-500">Session: {sessionId}</p>
          </div>
          <div className="flex items-center gap-2">
            <span
              className={`w-3 h-3 rounded-full ${
                isConnected ? 'bg-green-500' : 'bg-red-500'
              }`}
            />
            <span className="text-sm">
              {isConnected ? 'Connected' : 'Disconnected'}
            </span>
          </div>
        </header>

        <div className="grid md:grid-cols-4 gap-6">
          <div className="md:col-span-3">
            <ExerciseView sessionId={sessionId} />
          </div>
          <div>
            <ParticipantList sessionId={sessionId} />
          </div>
        </div>
      </div>
    </main>
  );
}
